import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Navbar from '../components/Navbar';

const MyBookmarksPage = () => {
    // --- CHANGE: Separate state for articles and videos ---
    const [bookmarkedArticles, setBookmarkedArticles] = useState([]);
    const [bookmarkedVideos, setBookmarkedVideos] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBookmarks = async () => {
            const token = localStorage.getItem('app_token');
            if (!token) {
                setError("You must be logged in to view your bookmarks.");
                setIsLoading(false);
                return;
            }

            try {
                const response = await axios.get('/api/bookmarks', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                // --- CHANGE: Filter bookmarks into separate arrays ---
                const articles = response.data.filter(item => item.content_type === 'article');
                const videos = response.data.filter(item => item.content_type === 'video');

                setBookmarkedArticles(articles);
                setBookmarkedVideos(videos);

            } catch (err) {
                setError("Failed to load your bookmarks. Please try again later.");
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchBookmarks();
    }, []);

    // Helper function to render a list of content cards
    const renderContentList = (items) => {
        if (items.length === 0) {
            return <p>No items saved in this category yet.</p>;
        }
        return (
            <div className="content-list">
                {items.map((item) => {
                    const linkPath = item.content_type === 'article'
                        ? `/articles/${item.content_id}`
                        : `/videos/${item.content_id}`;
                    
                    return (
                        <Link to={linkPath} key={`${item.content_type}-${item.content_id}`} className="content-card">
                            <img src={item.thumbnail_url} alt={item.title} className="content-card-thumbnail" />
                            <div className="content-card-body">
                                <h3 className="content-card-title">{item.title}</h3>
                                <p className="content-card-description">{item.category}</p>
                            </div>
                        </Link>
                    );
                })}
            </div>
        );
    };
    
    // Main render logic for the page
    const renderPageContent = () => {
        if (isLoading) return <p>Loading your saved items...</p>;
        if (error) return <p className="error-message">{error}</p>;
        if (bookmarkedArticles.length === 0 && bookmarkedVideos.length === 0) {
            return <p>You haven't saved any items yet. Start exploring and bookmark content you like!</p>;
        }

        return (
            // --- CHANGE: Render separate sections for each content type ---
            <div className="flex flex-col gap-8">
                <section>
                    <h2 className="section-title">Saved Articles</h2>
                    {renderContentList(bookmarkedArticles)}
                </section>

                <section>
                    <h2 className="section-title">Saved Videos</h2>
                    {renderContentList(bookmarkedVideos)}
                </section>
            </div>
        );
    };


    return (
        <div className="app-container">
            <Header title="My Bookmarks" showBackButton={true} />
            <main className="page-padding">
                {renderPageContent()}
            </main>
            <Navbar />
        </div>
    );
};

export default MyBookmarksPage;
